export default () => ({
  managers: [],
  manager: null,
  hasData: false,
  error: ''
});
